export default "__VITE_ASSET__cc23ba04__"